/**
 * Environment Layout Component
 * Renders the standard Layout around the authenticated page routes.
 * @packageDocumentation
 */

import { Layout } from '@/components/Layout';

/**
 * Layout route element for the authenticated pages; it renders the standard Layout.
 * Tenant state is managed by the Zustand store, not URL segments.
 *
 * @returns { JSX.Element } The environment layout element.
 */
export const EnvironmentLayout = () => <Layout />;
